import React, { Component } from 'react'
import axios from 'axios';
import { Notifications } from '../common/notification';
import Select from 'react-select';
import { BILLING_CREATED } from '../../config/rest_endpoints';


export class AccountBilling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            charges: '',
            rate: '',
            selectedCharges: null,
            selectedtype: null,
            optionsConnectCharges: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '24s', label: '24s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            optionsAccountType: [
                { value: 'Postpay', label: 'Postpay' },
                { value: 'Prepay', label: 'Prepay' }
            ],
            roundMethod: [
                { value: '*up', label: 'Up' },
                { value: '*down', label: 'Down' }
            ],
            selectRoundMethod: '',
            roundDigits: [
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' }
            ],
            selectRoundDigits: '',
            subsequent: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            subsequentSelect: '',
            billList: [],
            msg: '',
        }
        this.handleSelectAccount = this.handleSelectAccount.bind(this)
        this.handleSelectCharges = this.handleSelectCharges.bind(this)
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onSubmitBill = this.onSubmitBill.bind(this)
        this.handleRoundDigitsSelect = this.handleRoundDigitsSelect.bind(this)
        this.handleRoundMethodSelect = this.handleRoundMethodSelect.bind(this)
        this.handleSubsequentSelect = this.handleSubsequentSelect.bind(this)
    }

    onHandleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelectCharges(selectedCharges) {
        this.setState({ selectedCharges });
        console.log(`Option selectedCharges:`, selectedCharges);
    };

    handleSelectAccount(selectedtype) {
        this.setState({ selectedtype });
        console.log(`Option selectedtype:`, selectedtype);
    };

    handleSubsequentSelect(subsequentSelect) {
        this.setState({ subsequentSelect })
    }

    handleRoundMethodSelect(selectRoundMethod) {
        this.setState({ selectRoundMethod })
    }

    handleRoundDigitsSelect(selectRoundDigits) {
        this.setState({ selectRoundDigits })
    }

    onSubmitBill() {
        const { User, userId, charges, rates, selectedCharges, subsequentSelect, selectRoundMethod, selectRoundDigits } = this.state
        var billingAdd = {
            "initialInc": selectedCharges.value,
            "connectFee": parseFloat(charges),
            "ratePerMin": parseFloat(rates),
            "subsequentInc": subsequentSelect.value,
            "roundingMethod": selectRoundMethod.value,
            "roundingDigits": parseInt(selectRoundDigits.value)
        }
        console.log('billingAdd', billingAdd)
        var headers = { 'Authorization': "Bearer " + User.token }
        axios.post(`${BILLING_CREATED}/${userId}/billing/create`, billingAdd, { headers }).then(res => {
            console.log('res :', res);
            if (res) {
                this.setState({
                    msg: res.data.message
                })
                Notifications.notify(this.state.msg, "Created", "success")
                this.billingListing()
            }
        })
    }

    render() {
        const { subsequentSelect, subsequent, selectRoundDigits, roundDigits, selectRoundMethod, roundMethod, charges, rates, selectedOption, optionsConnectCharges, optionsAccountType, selectedCharges, selectedtype, billList, isGetting, isError } = this.state

        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Connect Charges</label>
                            <input type="number" className="form-control" name="charges" value={charges} onChange={this.onHandleChange} placeholder="Enter charges" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Rate Per Min</label>
                            <input type="number" className="form-control" name="rates" value={rates} onChange={this.onHandleChange} placeholder="Enter rate" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Initial Increment</label>
                            <Select
                                value={selectedCharges}
                                onChange={this.handleSelectCharges}
                                options={optionsConnectCharges}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label>Account Type</label>
                        <Select
                            value={selectedtype}
                            onChange={this.handleSelectAccount}
                            options={optionsAccountType}
                            isDisabled
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Subsequent Increment</label>
                            <Select
                                value={subsequentSelect}
                                onChange={this.handleSubsequentSelect}
                                options={subsequent}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Rounding Method</label>
                            <Select
                                value={selectRoundMethod}
                                onChange={this.handleRoundMethodSelect}
                                options={roundMethod}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Rounding Digits</label>
                            <Select
                                value={selectRoundDigits}
                                onChange={this.handleRoundDigitsSelect}
                                options={roundDigits}
                            />
                        </div>
                    </div>
                </div>
                <div className="row ml-auto">
                    <div className="col-md-6 ml-auto">
                        <button type="submit" className="btn btn-light float-right" onClick={this.onSubmitBill} ><i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " :"icon-coins ml-1"}></i>Add Bill</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default AccountBilling
